var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.computedClass,style:({ marginTop: 0, marginBottom: 0 }),attrs:{"disabled":_vm.disabled},on:{"click":_vm.downloadEpack}},[_c('Download')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }